interface DecodedToken {
  roles?: string[];
  wids?: string[];
  scp?: string;
  idtyp?: string;
}

const AUTHORITY = process.env.REACT_APP_AUTHORITY || "";
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || "";
const POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "";
const AZURE_CLIENT_ID = process.env.REACT_APP_AZURE_CLIENT_ID || "";

export const msalConfig = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
};

export const getRolesFromToken = (decodedToken: DecodedToken): string[] => {
  return decodedToken.roles || 
         decodedToken.wids || 
         (decodedToken?.scp ? decodedToken?.scp?.split(" ") : []);
};
